import React from 'react';
import { observer } from 'mobx-react';
import { RadioButtonInput } from './RadioButtons.style';

interface RadioButtonItemPropsTypes<T extends string> {
    name: string,
    isDisabled: boolean,
    isChecked: boolean,
    value: T,
    onChange?: (newValue: T) => void,
}

@observer
export class SingleRadioButton<T extends string> extends React.Component<RadioButtonItemPropsTypes<T>> {
    public render(): React.ReactNode {
        const { value, isDisabled, isChecked } = this.props;

        return (
            <RadioButtonInput
                type='radio'
                value={value}
                disabled={isDisabled}
                checked={isChecked}
                onChange={this.handleChange}
            />
        );
    }

    public handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        event.stopPropagation();
        if (this.props.onChange !== undefined) {
            this.props.onChange(this.props.value);
        }
    }
}
